import apiFetch from '../../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `dossier/sale/${dossierId}`, method: 'GET', token: token })
}
